import React from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import { StatsCardType } from "./StatsCard.types";

const StatsCard = ({
  title,
  value,
  subtitle,
  icon,
  loading = false,
}: StatsCardType) => {
  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        padding: 4,
        minWidth: 150,
        display: "flex",
        gap: 3,
        borderRadius: 2,
        border: "0.5px solid #DFE0E5",
      }}
    >
      <Box mb={1}>
        {loading ? (
          <Skeleton variant="circular" width={40} height={40} />
        ) : (
          icon
        )}
      </Box>
      <Box>
        {loading ? (
          <>
            <Skeleton variant="text" width={60} height={28} />
            <Skeleton variant="text" width={80} height={20} />
          </>
        ) : (
          <>
            <Typography variant="h3" color="grey.100" lineHeight={1.4}>
              {value}
            </Typography>
            <Typography variant="label2R" color="grey.90" lineHeight={1}>
              {title}
              {subtitle && (
                <Typography variant="label2R" color="grey.80">
                  &nbsp;( {subtitle} )
                </Typography>
              )}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default StatsCard;
